@if (hasLabel()) {
  <label class="FieldLabel" [for]="uniqueInputId()">{{ label() }}</label>
}

<p-inputGroup>
  @if (inputGroupLabel() && inputGroupLabel() != "") {
    <p-inputgroup-addon>
      <span class="test-city-input">{{ inputGroupLabel() }}</span>
    </p-inputgroup-addon>
  }

  <input
    pInputText
    class="test-zipcode"
    [class.ng-invalid]="formControl()?.invalid"
    type="text"
    [ngModel]="textValue()"
    [attr.aria-label]="'shared.Zipcode' | translate"
    [attr.aria-invalid]="formControl()?.invalid && formControl().touched && formControl().dirty"
    [maxLength]="inputMaxLength()"
    [id]="uniqueInputId()"
    [disabled]="disabled()"
    [placeholder]="'shared.EnterZip' | translate"
    (keyup)="onChanged($event)"
  />
</p-inputGroup>

<!-- Validation error messages  -->
@if (formControl()?.errors && formControl().touched && formControl().dirty) {
  <div aria-atomic="true" role="region" aria-live="polite">
    @if (formControl().errors.required) {
      <p class="field-error" translate>errorMessages.MustBeFilled</p>
    }

    @if (formControl().errors.length) {
      <p class="field-error" translate [translateParams]="{ length: inputMaxLength() }">errorMessages.MustBeXDigits</p>
    }

    @if (formControl().errors.maxLength) {
      <p class="field-error" translate [translateParams]="{ length: inputMaxLength() }">errorMessages.MaxXDigits</p>
    }

    @if (formControl().errors.digitsOnly) {
      <p class="field-error" translate>errorMessages.OnlyDigits</p>
    }
  </div>
}
